import { useQueryClient } from "@tanstack/react-query";
import { boronClient } from "../../../api";
import { useBoronMutation } from "../../../hooks/http/useBoronMutation";
import type { StudentFollowPromptFormValues } from "./StudentFollowPromptForm/validationSchema";
import { buildStudentFollowPromptQueryKey } from "./useFetchStudentFollowPrompt";

export const useUpdateStudentFollowPrompt = ({
  sectionId,
}: {
  sectionId: string;
}) => {
  const queryClient = useQueryClient();

  return useBoronMutation(
    async (values: StudentFollowPromptFormValues) =>
      await boronClient.PUT(
        "/api/v1/sections/{section_id}/student_follow_prompt",
        {
          params: { path: { section_id: sectionId } },
          body: { student_follow_prompt: values },
        },
      ),
    {
      onSuccess: (data) => {
        queryClient.setQueryData(
          buildStudentFollowPromptQueryKey(sectionId),
          data,
        );
      },
    },
  );
};
